import React, { Component } from 'react';
import { FileText, Download, X, ExternalLink } from 'lucide-react';
import i18n from '../../../../../i18n';
import '../../../../../styles/components/auction-attachments.scss';

class AuctionAttachments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            modalUrl: '',
            modalLabel: '',
        };
    }

    getAttachments() {
        const { auction } = this.props;
        const attachments = [];

        if (auction.file_contract) {
            attachments.push({ label: i18n.t('contracts') || 'Contracts', url: auction.file_contract });
        }
        if (auction.file_terms) {
            attachments.push({ label: i18n.t('terms_conditions') || 'Terms & Conditions', url: auction.file_terms });
        }
        if (auction.file_payment_terms) {
            attachments.push({ label: i18n.t('payment_terms') || 'Payment Terms', url: auction.file_payment_terms });
        }
        if (auction.file_additional_information) {
            attachments.push({ label: i18n.t('additional_information') || 'Additional Information', url: auction.file_additional_information });
        }

        if (auction.attachments && auction.attachments.length > 0) {
            auction.attachments.forEach((att) => {
                attachments.push({
                    label: att.name || att.label || att.title || 'Document',
                    url: att.url || att.file || att.path,
                });
            });
        }

        return attachments;
    }

    openModal = (url, label) => {
        this.setState({ modalOpen: true, modalUrl: url, modalLabel: label });
        document.body.style.overflow = 'hidden';
    };

    closeModal = () => {
        this.setState({ modalOpen: false, modalUrl: '', modalLabel: '' });
        document.body.style.overflow = '';
    };

    handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            this.closeModal();
        }
    };

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    render() {
        const attachments = this.getAttachments();
        const { modalOpen, modalUrl, modalLabel } = this.state;

        if (attachments.length === 0) return null;

        return (
            <>
                <div className="aat-panel">
                    <div className="aat-header">
                        <FileText size={18} className="aat-header__icon" />
                        <span>{i18n.t('documents_attachments') || 'Attachments'}</span>
                        <span className="aat-header__count">{attachments.length}</span>
                    </div>

                    <div className="aat-list">
                        {attachments.map((file, i) => (
                            <div
                                key={i}
                                className="aat-item"
                                onClick={() => this.openModal(file.url, file.label)}
                            >
                                <div className="aat-item__icon">
                                    <FileText size={20} />
                                </div>
                                <span className="aat-item__label">{file.label}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── PDF Modal ── */}
                {modalOpen && (
                    <div className="aat-modal-backdrop" onClick={this.handleBackdropClick}>
                        <div className="aat-modal">
                            {/* Header */}
                            <div className="aat-modal__header">
                                <div className="aat-modal__title">
                                    <FileText size={18} />
                                    <span>{modalLabel}</span>
                                </div>
                                <div className="aat-modal__actions">
                                    <a
                                        href={modalUrl}
                                        download
                                        className="aat-modal__btn"
                                        title={i18n.t('download') || 'Download'}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <Download size={16} />
                                    </a>
                                    <a
                                        href={modalUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="aat-modal__btn"
                                        title={i18n.t('open_in_new_tab') || 'Open in new tab'}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <ExternalLink size={16} />
                                    </a>
                                    <button
                                        className="aat-modal__btn aat-modal__btn--close"
                                        onClick={this.closeModal}
                                    >
                                        <X size={18} />
                                    </button>
                                </div>
                            </div>

                            {/* PDF iframe */}
                            <div className="aat-modal__body">
                                <iframe
                                    src={modalUrl}
                                    className="aat-modal__iframe"
                                    title={modalLabel}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default AuctionAttachments;